import { Tabs, TabsProps } from "antd";
import NoticeView from "./NoticeView";
import AcceleratorManagement from "./Accelerator/AcceleratorManagement";
import RecivedAccelerators from "./Accelerator/RecivedAccelerators";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";

const NoticeContainer = () => {
  const path = useLocation();
  const [getTab, setTab] = useState("1");
  useEffect(() => {
    const searchParams = new URLSearchParams(path.search);
    const tab = searchParams.get("tab");
    console.log("tabFromContainer", tab);

    if (tab !== undefined && tab !== null) {
      setTab(tab);
    }
  }, [path]);
  const navigate = useNavigate();
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "همه آگهی ها",
      children: <NoticeView tabNumber={Number.parseInt(getTab)} />,
    },
    // {
    //   key: "2",
    //   label: "آگهی های من",
    //   children: <NoticeView tabNumber={Number.parseInt(getTab)} />,
    // },
    {
      key: "3",
      label: "پیشنهاد های ارسالی",
      children: <NoticeView tabNumber={Number.parseInt(getTab)} />,
    },
    {
      key: "4",
      label: "شتاب شده به من",
      children: <RecivedAccelerators />,
    },
  ];
  const onChange = (key: string) => {
    setTab(key);
    navigate(`/Feed?tab=${key}`);
  };

  return (
    <>
      <Tabs
        style={{ fontFamily: "YekanBakhVF", position: "fixed", width: "100%" }}
        tabBarStyle={{ marginBottom: 1 }} // Reduces spacing below tab headers
        activeKey={getTab}
        items={items}
        onChange={onChange}
      />
    </>
  );
};
export default NoticeContainer;
